export default __webpack_public_path__ + "static/media/ic_buscar_precios_btn.a4674b2a.svg";